import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import Ref from '@/components/Ref/Ref.vue'

export default Node.create({
    name: 'Ref',
    inline: true,
    group: 'inline',
    content: 'inline*',

    addAttributes() {
        return {
            type: {
                default: "Ref"
            },
            ref: {
                default: ''
            }
        }
    },

    parseHTML() {
        return [
            {
                tag: 'ref',
            },
        ]
    },

    renderHTML({ HTMLAttributes }) {
        return ['ref', mergeAttributes(HTMLAttributes)]
    },

    addNodeView() {
        return VueNodeViewRenderer(Ref)
    },
})